import { Therapy } from '@pia/pia.shared';
import { Pipe, PipeTransform } from '@angular/core';
import { Therapies } from 'src/app/shared/models/therapy';

@Pipe({
  name: 'therapyPipe',
  pure: true,
})
export class TherapyPipe implements PipeTransform {
  transform(therapyId: Therapy): string {
    const therapy = Therapies.therapyItems.find(therapyItem => therapyItem.id === therapyId);
    if (therapy) {
      return therapy.abbreviation;
    }
    return Therapies.getTherapy(0).abbreviation;
  }
}
